import React, { useEffect, useState } from "react"
import Select from "@mui/material/Select";
import MenuItem from '@mui/material/MenuItem';
import '../styles.css'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import blogFetch from "../../../axios/config";

export default function ModalStatusMoldeFerramentaria({
  item,
  setShow,
  show,
  list
}) {
  const [motivo, setMotivo] = useState([]);
  const [selectedMotivo, setSelectedMotivo] = useState('');

  useEffect(() => {
    GetMotivo();
  }, []);

  const GetMotivo = async () => {
    try {
      const { data } = await blogFetch.get(`/ISAGA_MoldePendenciasMotivo`);
      setMotivo(data);
    } catch (error) {
      console.error(error);
    }
  };

  const postMoldePendencia = async () => {
    try {
      await blogFetch.post(`ISAGA_MoldePendencias`, {
        Molde_Key: item.molde_Key,
        Molde_Pend_Status: "ABERTO",
        Molde_Pend_Mot_Key: selectedMotivo,
        Molde_Pend_Obs: ""
      });
    } catch (e) {
      console.error(e)
    } finally {
    }
  }

  const putMolde = async () => {
    try {
      await blogFetch.put(`/ISAGA_Moldes`, {
        molde_Key: item.molde_Key,
        molde_Status: "MANUTENCAO",
      });
    } catch {

    } finally {

    }
  }

  const updateMolde = async () => {
    await postMoldePendencia()
    await putMolde()
    setShow(false)
    await list(0, 50, "");
  }

  const handleChange = (event) => {
    setSelectedMotivo(event.target.value);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => setShow(false)}
      >
        <Modal.Header closeButton >
          <h2 className="title_tables">
            SELECIONE O MOTIVO
          </h2>
        </Modal.Header>
        <Modal.Body>
          <Select
            className="w-100"
            value={selectedMotivo}
            label="Motivo"
            onChange={handleChange}
          >
            {motivo.map((item) => (
              <MenuItem key={item.molde_Pend_Mot_Key} value={item.molde_Pend_Mot_Key}>
                {item.molde_Pend_Mot_Descricao}
              </MenuItem>
            ))}
          </Select>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => updateMolde()}>
            CONFIRMAR
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

